module.exports = __webpack_public_path__ + "fonts/AnyConv.com__SourceSansPro-Bold.d3f22620.woff";